export default __webpack_public_path__ + "static/media/phonics_gray.e353ddfc.svg";